import { Ability } from '@casl/ability';

export const ability = new Ability([]);
export const abilityConfig = new Ability([]);

export const parseConfigurationsForCASL = (configurations) => {
  const filterObjects = (resource) => {
    const privilege = configurations[resource];
    if (typeof privilege !== 'object' || !privilege) {
      return;
    }

    let customActions = [];
    Object.entries(privilege).forEach(([key]) => {
      if (Array.isArray(privilege[key])) {
        privilege[key].forEach((val) => {
          if (typeof val !== 'object') {
            customActions.push(`${key}.${val}`);
          }
        });
      } else if (typeof privilege[key] === 'object' && privilege[key] !== null) {
        const privilegeKey = privilege[key];
        Object.entries(privilegeKey).forEach(([keyName]) => {
          if (typeof privilegeKey[keyName] === 'boolean' && privilegeKey[keyName]) {
            customActions.push(`${key}.${keyName}`);
          }
        });
      } else if (privilege[key]) {
        customActions.push(key);
      }
    });
    return { subject: resource, actions: customActions };
  };

  const configAbilities = Object.keys(configurations)
    .map(filterObjects)
    .filter((value) => value);
  return configAbilities;
};

export const parsePrivilegesForCASL = (privileges) => {
  const filterObjects = ([key, value]) => {
    return {
      subject: key,
      actions: value.map((_value) => (_value === '*' ? 'manage' : _value)),
    };
  };

  const userPrivileges = privileges?.privileges || privileges;

  const privilegeAbilities = (userPrivileges ? Object.entries(userPrivileges) : null)
    ?.map(filterObjects)
    .filter((value) => value);

  return privilegeAbilities;
};

export const updateAbilities = (privileges) => {
  ability.update(parsePrivilegesForCASL(privileges));
};

export const updateAbilitiesConfig = (configurations) => {
  abilityConfig.update(parseConfigurationsForCASL(configurations));
};
